import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { InventarioService } from '../inventario.service';

/*  KÉSZLET – a készletnyilvántartott cikkek raktáranként, a választott értékelési módszer (FIFO /
 *  csúsztatott / havi átlagár) szerinti értékkel; a minimum alatti cikkek kiemelve (rendelési javaslat). */
@Component({
  selector: 'app-inventario-keszlet',
  templateUrl: './keszlet.component.html',
  styleUrls: ['../../naplo/naplo-shared.scss', '../inventario-shared.scss'],
})
export class KeszletComponent implements OnInit, OnDestroy {
  cikkek: any[] = [];
  raktarak: any[] = [];
  raktar = '';
  kereso = '';
  csakHiany = false;
  csakVan = false;
  modszerNev = '';
  private sub?: Subscription;
  constructor(public inv: InventarioService) {}
  get u() { return this.inv.aktiv.ugyfelId; }
  async ngOnInit() { await this.inv.init(); this.sub = this.inv.aktiv$.subscribe(() => this.frissit()); }
  ngOnDestroy() { this.sub?.unsubscribe(); }
  async frissit() {
    if (!this.u) return;
    try { const r: any = await this.inv.get(`/cikkek/${this.u}`); this.cikkek = (r.cikkek || []).filter((c: any) => +c.keszletes); this.raktarak = r.raktarak || []; this.modszerNev = r.modszer_nev || ''; }
    catch { this.cikkek = []; }
  }
  menny(c: any) { return this.raktar ? (c.raktarankent?.[this.raktar] || 0) : c.keszlet; }
  ertek(c: any) { return this.raktar ? Math.round(c.raktar_ertek?.[this.raktar] || 0) : c.ertek; }
  get lathato() {
    const k = this.kereso.trim().toLowerCase();
    return this.cikkek.filter((c) => (!this.csakHiany || c.hiany) && (!this.csakVan || this.menny(c) !== 0)
      && (!k || [c.nev, c.cikkszam, c.vonalkod].some((x) => String(x || '').toLowerCase().includes(k))));
  }
  get osszErtek() { return this.lathato.reduce((n, c) => n + (this.ertek(c) || 0), 0); }
  szam(v: any) { return v == null ? '' : Number(v).toLocaleString('hu-HU', { maximumFractionDigits: 2 }); }
}
